import axios from 'axios';

// Use different URLs for development and production
const getBaseURL = () => {
  if (import.meta.env.DEV) {
    // Development mode
    return import.meta.env.VITE_API_BASE_URL || 'https://api.wiwi.co.il/api';
  } else {
    // Production mode
    return 'https://api.wiwi.co.il/api';
  }
};

const api = axios.create({
  baseURL: getBaseURL(),
  timeout: 0,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor (optional)
api.interceptors.request.use(
  (config) => {
    // Add auth token if available
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Return response for 400 status instead of throwing error
    if (error.response?.status === 400) {
      return error.response;
    }

    // Handle common errors
    if (error.response?.status === 401) {
      // Handle unauthorized
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;